import { render, staticRenderFns } from "./uploadwithdraw.vue?vue&type=template&id=64ebe958&"
import script from "./uploadwithdraw.vue?vue&type=script&lang=js&"
export * from "./uploadwithdraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports